import React from 'react';
import styled from 'styled-components';
import axios from 'axios';

const SearchContainer = styled.div`
	padding: 48px 0 40px 0;
	flex: 1;

	@media (max-width: 719px) {
		padding-left: 0;
	}
`;

const SearchBar = styled.div`
	position: relative;
	width: 100%;
	/*max-width: 480px;*/
	height: 64px;
	margin: 0;
	padding: 0;
	background: #f2f2f2;
	border-radius: 4px;
	/*box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);*/
`;

const SearchIcon = styled.div`
	position: absolute;
	top: 22px;
	left: 16px;
	width: 20px;
	height: 20px;
	opacity: 0.8;
`;

const SearchInput = styled.input`
	width: 100%;
	height: 64px;
	padding-left: 44px;
	padding-right: 16px;
	background: none;
	border: 2px solid transparent;
	border-radius: 4px;
	outline: none;

	&:focus {
		border: 2px solid black;
	}
`;

function Search(props) {
	const refSearchInput = React.useRef(null);
	const [userIdentifer, setUserIdentifier] = React.useState('');

	const getCookie = (name) => {
		var nameEQ = name + '=';
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	};

	React.useEffect(() => {
		if (refSearchInput && refSearchInput.current) {
			refSearchInput.current.focus();
			setUserIdentifier(getCookie('super-secret-access-code'));
		}
	}, []);

	return (
		<SearchContainer>
			<SearchBar>
				<SearchIcon>
					<svg
						width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g opacity="0.8">
							<path
								d="M17.8395 16.4605L14.1641 12.7852C15.0489 11.6072 15.5266 10.1733 15.525 8.7C15.525 4.93672 12.4633 1.875 8.7 1.875C4.93672 1.875 1.875 4.93672 1.875 8.7C1.875 12.4633 4.93672 15.525 8.7 15.525C10.1733 15.5266 11.6072 15.0489 12.7852 14.1641L16.4605 17.8395C16.6466 18.0058 16.8893 18.0945 17.1387 18.0876C17.3881 18.0806 17.6255 17.9784 17.8019 17.8019C17.9784 17.6255 18.0806 17.3881 18.0876 17.1387C18.0945 16.8893 18.0058 16.6466 17.8395 16.4605V16.4605ZM3.825 8.7C3.825 7.73582 4.11091 6.79329 4.64659 5.9916C5.18226 5.18991 5.94363 4.56506 6.83442 4.19609C7.72521 3.82711 8.70541 3.73057 9.65107 3.91867C10.5967 4.10677 11.4654 4.57107 12.1471 5.25285C12.8289 5.93464 13.2932 6.80328 13.4813 7.74893C13.6694 8.69459 13.5729 9.67479 13.2039 10.5656C12.8349 11.4564 12.2101 12.2177 11.4084 12.7534C10.6067 13.2891 9.66418 13.575 8.7 13.575C7.40755 13.5734 6.16847 13.0593 5.25457 12.1454C4.34066 11.2315 3.82655 9.99245 3.825 8.7V8.7Z"
								fill="black"
							/>
						</g>
					</svg>
				</SearchIcon>
				<SearchInput
					ref={refSearchInput}
					onChange={(e) => {
						props.onSearchChange(e);
					}}
					onKeyDown={(e) => {
						if (e.keyCode === 8) {
							axios
								.post('https://nugu-backend.vercel.app/search', {
									id: userIdentifer ? userIdentifer : '',
									search: props.searchInputValue,
								})
								.then(function(response) {})
								.catch(function(error) {})
								.then(function() {});
						}
					}}
					value={props.searchInputValue}
					placeholder="투자자 검색하기"
				/>
			</SearchBar>
		</SearchContainer>
	);
}

export default Search;
